import { render, staticRenderFns } from "./CustomInputNumberComponent.vue?vue&type=template&id=6748e23c"
import script from "./CustomInputNumberComponent.vue?vue&type=script&lang=js"
export * from "./CustomInputNumberComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports